<template>
  <div :class="['BaseDivider', { 'BaseDivider--dark': dark }]">
    <span
      v-if="$slots.default"
      class="BaseDivider__content"
    >
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    dark: { type: Boolean, default: false }
  }
}
</script>

<style lang="postcss">
.BaseDivider {
  display: block;
  width: 100%;
  margin: 0;
  text-align: center;
  position: relative;

  .BaseDivider__content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
